import PropTypes from 'prop-types'

const FlagDE = ({ width = '22', height = '16', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <clipPath id="flag-de-round">
        <rect width="24" height="16" rx="3" />
      </clipPath>
    </defs>
    <g clipPath="url(#flag-de-round)">
      <rect width="24" height="16" fill="#000000" />
      <rect y="5.333" width="24" height="5.333" fill="#DD0000" />
      <rect y="10.666" width="24" height="5.334" fill="#FFCE00" />
    </g>
  </svg>
)

FlagDE.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
}

export default FlagDE
